<div class="page-container">
    <!-- Breadcrumb Menu -->
    <div class="breadcrumb-menu">
        <div data-cy="sys-status-fcu-breadcrumb-fcu" (click)="unselectFcu()">
            {{ "system-status.page-title.fcu" | translate }}
        </div>
        {{ "/" }}
        <div
            data-cy="sys-status-fcu-breadcrumb-selected-fcu"
            class="breadcrumb-menu"
            [ngClass]="{ active: !selectedFu }"
            (click)="unselectFu()"
        >
            {{ "system-status.page-title.fcu" | translate }}
            {{ " " + fcuIndex }}
        </div>
        <div *ngIf="selectedFu">{{ "/" }}</div>
        <div
            data-cy="sys-status-fcu-breadcrumb-fu"
            class="breadcrumb-menu active"
            *ngIf="selectedFu"
        >
            {{ "system-status.fu.title" | translate }}
            {{ " " + (selectedFuIndex + 1) }}
        </div>
    </div>

    <!-- Page Title -->
    <div
        data-cy="sys-status-fcu-selected-fcu-title"
        class="page-title"
        *ngIf="!selectedFu; else fuTitle"
    >
        {{ "system-status.page-title.fcu" | translate }}
        {{ " " + fcuIndex }}
    </div>
    <ng-template #fuTitle>
        <div data-cy="sys-status-fcu-selected-fu-title" class="page-title">
            {{ "system-status.fu.title" | translate }}
            {{ " " + (selectedFuIndex + 1) }}
        </div>
    </ng-template>

    <!-- System Status -->
    <div class="selected-fcu-wrapper">
        <div
            class="status-container"
            *ngIf="!selectedFu; else fuStatusIndicator"
        >
            <ng-container *ngFor="let item of selectedFcu | keyvalue">
                <div *ngIf="item.key === 'fcuA'" class="status">
                    <ng-container
                        *ngTemplateOutlet="
                            fcuTemplate;
                            context: {
                                fcu: item.value,
                                title: 'FCU A',
                                key: 'fcuA',
                            }
                        "
                    >
                    </ng-container>
                </div>
                <div *ngIf="item.key === 'fcuB'" class="status">
                    <ng-container
                        *ngTemplateOutlet="
                            fcuTemplate;
                            context: {
                                fcu: item.value,
                                title: 'FCU B',
                                key: 'fcuB',
                            }
                        "
                    >
                    </ng-container>
                </div>
            </ng-container>
        </div>

        <div class="ports-container">
            <div class="ports-wrapper" *ngIf="!selectedFu">
                <div *ngFor="let fu of selectedFcu.fu; index as i">
                    <app-fu-list-status-indicator
                        [isReceivingData]="isReceivingData"
                        [index]="i"
                        [fuStatus]="fu"
                        (onSelectFu)="handleSelectFu($event)"
                    ></app-fu-list-status-indicator>
                </div>
            </div>
            <div class="ports-wrapper" *ngIf="selectedFu">
                <div *ngFor="let slot of selectedFu.slots; index as i">
                    <app-fu-slot-status-indicator
                        [isReceivingData]="isReceivingData"
                        [index]="i"
                        [fuSlot]="slot"
                    ></app-fu-slot-status-indicator>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #fcuTemplate let-fcu="fcu" let-title="title" let-key="key">
    <div data-cy="sys-status-fcu-selected-fcu-container" class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-fcu-selected-fcu-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms(key) && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms(key) && isReceivingData,
                }"
            />
            {{ title }}
        </div>
        <div class="location-container" *ngIf="fcu.active">
            <div data-cy="sys-status-fcu-active-label" class="active-status">
                {{ "system-status.fcu.active" | translate }}
            </div>
        </div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.run) === 'status-error',
        }"
    >
        {{ "system-status.fcu.run" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-run-icon"
            svgIcon="{{ getIcon(fcu.run) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.initialized) === 'status-error',
        }"
    >
        {{ "system-status.fcu.initialized" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-init-icon"
            svgIcon="{{ getIcon(fcu.initialized) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.sync) === 'status-error',
        }"
    >
        {{ "system-status.fcu.sync" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-sync-icon"
            svgIcon="{{ getIcon(fcu.sync) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.files) === 'status-error',
        }"
    >
        {{ "system-status.fcu.files" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-files-icon"
            svgIcon="{{ getIcon(fcu.files) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.memory) === 'status-error',
        }"
    >
        {{ "system-status.fcu.memory" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-memory-icon"
            svgIcon="{{ getIcon(fcu.memory) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.ethernetA) === 'status-error',
        }"
    >
        {{ "system-status.fcu.ethernetA" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-ethernet-a-icon"
            svgIcon="{{ getIcon(fcu.ethernetA) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.ethernetB) === 'status-error',
        }"
    >
        {{ "system-status.fcu.ethernetB" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-ethernet-b-icon"
            svgIcon="{{ getIcon(fcu.ethernetB) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.fieldbusA) === 'status-error',
        }"
    >
        {{ "system-status.fcu.fieldbusA" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-fieldbus-a-icon"
            svgIcon="{{ getIcon(fcu.fieldbusA) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.fieldbusB) === 'status-error',
        }"
    >
        {{ "system-status.fcu.fieldbusB" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-fieldbus-b-icon"
            svgIcon="{{ getIcon(fcu.fieldbusB) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.fieldNetA) === 'status-error',
        }"
    >
        {{ "system-status.fcu.fieldNetA" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-fieldnet-a-icon"
            svgIcon="{{ getIcon(fcu.fieldNetA) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.fieldNetB) === 'status-error',
        }"
    >
        {{ "system-status.fcu.fieldNetB" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-fieldnet-b-icon"
            svgIcon="{{ getIcon(fcu.fieldNetB) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.port1) === 'status-error',
        }"
    >
        {{ "system-status.fcu.port1" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-port-1-icon"
            svgIcon="{{ getIcon(fcu.port1) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.port2) === 'status-error',
        }"
    >
        {{ "system-status.fcu.port2" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-port-2-icon"
            svgIcon="{{ getIcon(fcu.port2) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.port3) === 'status-error',
        }"
    >
        {{ "system-status.fcu.port3" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-port-3-icon"
            svgIcon="{{ getIcon(fcu.port3) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
    <div
        class="status-wrapper"
        [ngClass]="{
            'alarm-font': getIcon(fcu.port4) === 'status-error',
        }"
    >
        {{ "system-status.fcu.port4" | translate }}
        <mat-icon
            *ngIf="isReceivingData"
            data-cy="sys-status-fcu-selected-fcu-port-4-icon"
            svgIcon="{{ getIcon(fcu.port4) }}"
            class="icon"
        />
        <div *ngIf="!isReceivingData" class="disconnected-line"></div>
    </div>
</ng-template>

<ng-template #fuStatusIndicator>
    <div class="status-container">
        <app-fu-status-indicator
            [isReceivingData]="isReceivingData"
            [index]="selectedFuIndex"
            [fuStatus]="selectedFu"
        ></app-fu-status-indicator>
    </div>
</ng-template>
